<template>
  <div class="userList electricityBill">
    <!-- 现金充值 rechargeDetail-->
    <div class="content">
      <div class="userList-top">
        <span style="font-size:16px">现金充值</span>
        <div class="btns" style="z-index: 8;">
          <!-- <el-button type="primary" size="mini" @click="exportList" class="last-el-button"
            :loading="loadingBtn">报表导出</el-button> -->
        </div>
      </div>

      <div class="medio">

        <div class="leftBox">
          <div class="topLeftTitleContent" style="background: #368ed9;">业主信息</div>
          <div class="text">
            <div class="label">业主姓名</div>
            <div class="txt">{{this.formData['用户名']}}</div>
          </div>
          <div class="text">
            <div class="label">手机号</div>
            <div class="txt">{{this.formData['手机号']}}</div>
          </div>
          <div class="text">
            <div class="label">业主编号</div>
            <div class="txt">{{this.formData['用户编号']}}</div>
          </div>
          <div class="text">
            <div class="label">地址</div>
            <div class="txt">{{this.formData['用户地址']}}</div>
          </div>
        </div>
        <div class="rightBox">
          <div class="topLeftTitleContent" style="background: #368ed9;">充值信息</div>
          <el-form ref="ruleForm" :model="temp" label-width="120px" :rules="rules">
            <el-form-item label="充值方式">
              <el-tag type="warning" size="mini">现金</el-tag>
            </el-form-item>
            <el-form-item label="充值金额" prop="amount">
              <el-input size="mini" style="width: 170px;" v-model="temp.amount" placeholder="请输入金额"
                oninput="value=value.replace(/[^0-9.]/g,'')">
                <span slot="suffix">元 </span>
              </el-input>
            </el-form-item>
            <el-form-item label="登陆密码" prop="password">
              <el-input size="mini" style="width: 170px;" v-model="temp.password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input size="mini" style="width: 170px;" v-model="temp.memo" placeholder="请输入备注"></el-input>
              <el-button type="primary" style="margin-left: 10px;" @click="submitForm">充值</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="search">
        <el-form ref="form" label-width="92px" size="medium" style="display: flex;width: auto;">
          <!-- <el-form-item label="订单号：">
            <el-input v-model="ownerName" placeholder="请输入订单号" class="el-input-mysmall"></el-input>
          </el-form-item> -->
          <el-form-item label="充值时间">
            <el-date-picker v-model="openTime" value-format="timestamp" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="mini" @click="search" style="margin-left: 10px;">查询</el-button>
        <el-button type="primary" size="mini">导出</el-button>
      </div>
      <div class="userList-table">
        <el-table :data="tableData2" v-loading="loading" stripe style="width: 100%" border>
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>

          <el-table-column prop="订单号" label="订单号" min-width="137" />
          <el-table-column prop="缴费金额" label="缴费金额" min-width="137" />
          <el-table-column prop="缴费状态" label="缴费状态" min-width="137" />
          <el-table-column prop="缴费时间" label="缴费时间" min-width="155" />
          <el-table-column prop="充值方式" label="充值方式" min-width="100" />
          <el-table-column prop="余额" label="余额" min-width="97" />
          <el-table-column prop="备注" label="备注" min-width="137" />
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[5,15, 25, 35, 45, 55]" :page-size="currentSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>


  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      downloadTable
    },
    watch: {
      formData (v,n) {
        this.search() //获取列表数据 
      }
    },
    data () {
      return {
        ownerName: '',
        openTime: '',
        rules: {
          amount: [
            {required: true,message: '请输入金额',trigger: 'blur'},
          ],
          password: [
            {required: true,message: '请输入密码',trigger: 'blur'}
          ],

        },
        temp: {},//充值参数
        loadingBtn: false,
        children_total: 0,
        children_params: {},//请求参数
        detail_status: false,//详情弹窗
        childrenList: [],//详情数据
        loading2: false,
        tableData2: [],
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-500,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {
          queryType: 'DAY'
        },
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 5,
        tableData: [],//表格数据
        datetimeValue: [new Date('2023/6/1').getTime(),new Date().getTime()],
        startDate: '',//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          }
        },
      };
    },
    props: {
      formData: {
        required: true,
        type: Object,
        default () {
          return ''
        }
      },
    },
    mounted () {
      this.search() //获取列表数据 
    },
    methods: {
      //重置
      resetForm (formName) {
        this.temp={}
        this.$refs['ruleForm'].resetFields();
      },
      submitForm (formName) {

        this.$refs['ruleForm'].validate((valid) => {
          if(valid) {
            this.getDataList()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      //搜索
      search () {
        // ownerName
        // beginTime,
        //    endTime,
        var params={
          targetIds: this.formData['用户id'],
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
        }
        if(this.openTime&&this.openTime.length) {
          params.beginTime=this.openTime[0];
          params.endTime=this.openTime[1];
        }
        this.loading=true;
        request({url: "/revenueManagement/getRechargeRecordBill.do",method: "get",params}).then(res => {
          this.loading=false;
          console.log(res,1);
          if(res.code==200) {
            this.tableData2=res.data.dataList
            this.total=res.data.total
          } else {
            this.tableData2=[]
            this.total=0
          }
        })
      },
      // 充值
      getDataList () {
        var data={
          "targetId": this.formData['用户id'],
          "type": "MeterReading",
          "detailType": "Recharge_CashPay",
          "amount": this.temp.amount,
          "password": hex_md5(this.temp.password),
          "memo": this.temp.memo,
        }
        request({url: "/revenueManagement/rechargeJY",method: "post",data}).then(res => {
          if(res.data) {
            this.$confirm(res.data);
            this.resetForm()
          }

        })
      },



      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-电费账单','.userList-table')


      },
      openDownloadFile (urlObj,saveName) {
        var openDownload=function(href,fileName) {
          var downloadElement=document.createElement('a');
          downloadElement.target="_blank";
          downloadElement.href=href;
          downloadElement.download=fileName||""; // HTML5新增的属性，指定保存文件名，可以不要后缀
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        }

        if(typeof urlObj=='object'&&urlObj instanceof Blob) {
          if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
            //针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            window.navigator.msSaveOrOpenBlob(urlObj,saveName);
          } else {
            var url=window.URL.createObjectURL(urlObj); // 创建blob地址
            openDownload(url,saveName);
            window.URL.revokeObjectURL(url); // 释放掉blob对象创建的地址
          }
        } else {
          openDownload(urlObj,saveName);
        }
      },
      //分页功能
      newgetNowPageDataList (v) {
        // 当前页显示
        this.search()

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .rightBox .el-form-item {
    margin-bottom: 0px;
  }

  .electricityBill .tableNest th {
    background-color: #f5f8fa !important;
    color: #999 !important;
  }

  .electricityBill .el-table__expanded-cell {
    background-color: #f5f8fa !important;
  }

  .electricityBill .el-table__expanded-cell {
    padding: 5px;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 44px;
  }
</style>
<style lang="scss" scoped>
  .medio {
    display: flex;
    padding: 20px;
  }

  .leftBox {
    border: 1px solid #d7d7d7;
    flex: 1;
    margin-right: 5px;
  }

  .leftBox .topLeftTitleContent {
    padding: 10px 0;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    font-size: 14px;
    font-weight: bold;
    padding-left: 20px;
  }

  .leftBox .text {
    display: flex;
    margin: 16px 0;
    align-items: center;
  }

  .leftBox .text .label {
    color: #999;
    width: 100px;
    text-align: right;
  }

  .leftBox .text .txt {
    color: #000;
    margin-left: 10px;
  }

  .rightBox {
    flex: 1;
    border: 1px solid #d7d7d7;
    margin-left: 5px;
  }

  .rightBox .topLeftTitleContent {
    padding: 10px 0;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    font-size: 14px;
    font-weight: bold;
    padding-left: 20px;
  }

  .rightBox .text {
    display: flex;
    margin: 16px 0;
    align-items: center;
  }

  .rightBox .text .label {
    color: #999;
    width: 100px;
    text-align: right;
  }

  .rightBox .text .txt {
    color: #000;
  }

  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
  }

  .box .li img {
    margin-right: 15px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }
      }


      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;
        left: -3px;

        .el-form-item {
          margin-bottom: 0px;
        }

        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        .el-table th {
          border-right: 1px solid #E6E6E6;
        }

        .el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    .el-form-item__label {
      padding: 0px;
    }



  }
</style>